import cloneDeep from 'lodash/cloneDeep';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectDetails} from '~/CreateFabricInvitation/reducers/details/selectors';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {valid_email} from '~/common/utils';
import {Button} from '~library/atoms/Button';
import {Input} from '~library/atoms/Input';
import {ResponsivePanel} from '~library/organisms/ResponsivePanel';
import './CohostOverlay.sass';

export const CohostOverlay = ({closeOverlay, overlayError, setOverlayError, isOpen}) => {
  const dispatch = useDispatch();

  const [numErrs, setNumErrs] = useState(0);
  const [submitted, setSubmitted] = useState(false);

  //* Initialize local state vars using values from the store
  const [cohost, setCohost] = useState(cloneDeep(useSelector(selectDetails)?.cohost));

  const validateCohost = (force) => {
    if (!submitted && !force) return false;
    const newCohost = {...cohost};
    let errorCount = 0;

    newCohost.nameError = null;
    newCohost.emailError = null;
    if (!newCohost.name || newCohost.name?.trim() === '') {
      newCohost.nameError = 'Co-host name is required (or you can remove the Co-host)';
      errorCount++;
    }
    const emailValidation = valid_email(newCohost.email);
    if (!emailValidation?.is_valid) {
      newCohost.emailError = emailValidation.error_message;
      errorCount++;
    }

    setNumErrs(errorCount);
    setCohost(newCohost);
    return errorCount === 0;
  };

  const saveCohost = (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (!validateCohost(true)) return;

    dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {cohost: {name: cohost.name, email: cohost.email}},
    });
    closeOverlay();
  };

  return (
    <ResponsivePanel
      isOpen={isOpen}
      onClose={closeOverlay}
      title="Co-Host"
      modalId="co-host"
      closeQaId="cohost-exit"
      showCover
      renderMobileViewAs="bottom-sheet"
    >
      <form onSubmit={saveCohost}>
        <div className="one-step-flow__overlay-body co-host__overlay">
          <OverlayCohost
            cohost={cohost}
            setCohost={(cohost) => {
              setOverlayError('');
              setCohost(cohost);
            }}
            validate={validateCohost}
            emailError={overlayError}
          />
        </div>
        <div className="one-step-flow__overlay-footer co-host__footer">
          <Button
            data-qa-id="cohost-save"
            disabled={submitted && numErrs > 0}
            onClick={saveCohost}
            variant="primary"
            size="large"
            formSubmit
          >
            Save
          </Button>
        </div>
      </form>
    </ResponsivePanel>
  );
};

const OverlayCohost = ({cohost, setCohost, validate, ...props}) => {
  const onChange = (e, field) => {
    cohost[field] = e.target.value;
    setCohost({...cohost});
    validate();
  };

  return (
    <div className="overlay-box">
      <Input
        label="Name"
        data-qa-id="event-cohostoverlay-name"
        error={cohost.nameError}
        value={cohost.name}
        onChange={(e) => onChange(e, 'name')}
        placeholder="Co-Host Name"
      />
      <Input
        label="Email Address"
        data-qa-id="event-cohostoverlay-email"
        error={cohost.emailError || props.emailError}
        value={cohost.email}
        onChange={(e) => onChange(e, 'email')}
        placeholder="Co-Host Email"
      />
    </div>
  );
};
